import React from "react";
import { Button, Card, Grid, Stack, TextField } from "@mui/material";
import Select from "react-select";

const PollFor = [
  { label: "All", value: 0 },
  { label: "LVB", value: 1 },
  { label: "State", value: 2 },
  { label: "City", value: 3 },
  { label: "Chapter", value: 4 }
];

const PollForCityUser = [
  { label: "All", value: 0 },
  { label: "City", value: 3 },
  { label: "Chapter", value: 4 }
];

const PollStatus = [
  { label: "All", value: 0 },
  { label: "Pending", value: 1 },
  { label: "Completed", value: 2 }
];

const PollSendStatus = [
  { label: "All", value: -1 },
  { label: "Unsent", value: 0 },
  { label: "Sent", value: 1 }
];

function PollFilters({ pollFilters, setPollFilters, loginUser }) {
  const forOptions = loginUser?.u_type === 1 ? PollForCityUser : PollFor;

  return (
    <Card className="p-20 mb-15">
      <Grid container spacing={2} sx={{ alignItems: "center" }}>
        <Grid item xs={2}>
          <Stack sx={{ my: "5px" }}>
            <label>Poll For</label>
            <Select
              menuPortalTarget={document.body}
              value={forOptions.find((c) => c.value === pollFilters.p_type) || null}
              onChange={(e) => setPollFilters({ ...pollFilters, p_type: e.value })}
              options={forOptions}
            />
          </Stack>
        </Grid>
        <Grid item xs={2}>
          <Stack>
            <label>Poll Status</label>
            <Select
              menuPortalTarget={document.body}
              value={PollStatus.find((c) => c.value === pollFilters.poll_status) || null}
              onChange={(e) => setPollFilters({ ...pollFilters, poll_status: e.value })}
              options={PollStatus}
            />
          </Stack>
        </Grid>
        <Grid item xs={2}>
          <Stack>
            <label>Send Status</label>
            <Select
              menuPortalTarget={document.body}
              value={PollSendStatus.find((c) => c.value === pollFilters.poll_send_status) || null}
              onChange={(e) => setPollFilters({ ...pollFilters, poll_send_status: e.value })}
              options={PollSendStatus}
            />
          </Stack>
        </Grid>
        <Grid item xs={4}>
          <Stack spacing={10}>
            <TextField
              style={{ marginTop: "20px" }}
              fullWidth
              autoComplete="off"
              type="text"
              size="small"
              label="Search by question"
              autoCorrect="off"
              value={pollFilters.search}
              onChange={(e) => setPollFilters({ ...pollFilters, search: e.target.value })}
            />
          </Stack>
        </Grid>
        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            marginTop: "20px"
          }}
        >
          <Button
            onClick={() =>
              setPollFilters({
                p_type: 0,
                poll_status: 0,
                poll_send_status: -1,
                search: ""
              })
            }
            variant="contained"
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}

export default PollFilters;
